import * as API from 'src/helpers/api_helper'
import * as URL from 'src/helpers/url_helper'

//

export const ConnectedAccountApi = (data) => API.post(`${URL.CONNECT_ACCOUNT}`, data)
export const ConnectedAccountDashboardApi = (data) =>
    API.post(`${URL.CONNECT_ACCOUNT_DASHBOARD_URL}`, data)
export const CreateStripeOnboardingLinkApi = (data) =>
    API.post(`${URL.CREATE_STRIPE_ONBOARDING_LINK}`, data)
export const GetStripeAccountStatusApi = (data) =>
    API.post(`${URL.GET_STRIPE_ACCOUNT_STATUS}`, data)
